// Shared, cached GET /api/ai/status so BriefPanel, TidyNote and the Training page don't each refetch it.
import { useEffect, useState } from 'preact/hooks';
import type { AiStatus } from '../../../src/shared/api-ai';
import { api } from '../api';

let cached: AiStatus | null = null;
let inflight: Promise<AiStatus | null> | null = null;

export function loadAiStatus(): Promise<AiStatus | null> {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = api.get<AiStatus>('/api/ai/status')
      .then((s) => { cached = s; return s; })
      .catch(() => null)                    // unknown status: AI buttons stay hidden
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/** null while loading or when the status could not be read (treat as "AI off"). */
export function useAiStatus(): AiStatus | null {
  const [s, setS] = useState<AiStatus | null>(cached);
  useEffect(() => {
    let alive = true;
    if (!cached) loadAiStatus().then((v) => { if (alive) setS(v); });
    return () => { alive = false; };
  }, []);
  return s;
}
